import { z } from "zod";
// ---------------------------------------------------------------------------
// DLR / Trazas de entrega — leídas de socialmanager.SM_NOTIFICACION_WAPP
// (append-only, una fila por evento) cruzada con SM_ENVIO_PLANTILLA para
// atribuir cada DLR a una campaña. SIEMPRE acotado por partición de fecha.
// ---------------------------------------------------------------------------
// Estados normalizados (lowercased). El core guarda casing mixto por proveedor.
export const dlrStatusEnum = z.enum([
    "enqueued",
    "sent",
    "delivered",
    "read",
    "failed",
    "lista negra",
    "other",
]);
// Ventana de consulta: obligatoria para partition pruning. El server impone
// un tope máximo de días para proteger la tabla de 254 GB.
// from/to DEBEN ser fechas 'YYYY-MM-DD' válidas: de eso depende el pruning y el
// tope de días — no se puede dejar como string libre.
const dateStr = z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, "Fecha debe ser YYYY-MM-DD")
    .refine((s) => !Number.isNaN(Date.parse(s)), "Fecha inválida");
export const dlrWindowSchema = z.object({
    from: dateStr.optional(),
    to: dateStr.optional(),
});
export const dlrCampaignParamsSchema = z.object({
    id: z.coerce.number().int().positive(),
});
export const dlrRecipientsQuerySchema = dlrWindowSchema.extend({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(200).default(50),
    q: z.string().trim().min(1).max(30).optional(), // teléfono
});
export const dlrMessageParamsSchema = z.object({
    messageid: z.string().min(1).max(80),
});
export const dlrFrequencyQuerySchema = dlrWindowSchema.extend({
    gran: z.enum(["minute", "hour", "day"]).default("hour"),
});
//# sourceMappingURL=dlr.js.map